<template>
  <div class="page-container" style="margin: 10px;">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>手工录入充值</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-form :model="newTrans" :rules="rules" label-position="right" label-width="120px" ref="newTrans">
        <el-row>
          <el-col :span="8">
            <el-form-item label="用户ID：" prop="userId">
              <el-input class="tx-common-input" v-model="newTrans.userId" placeholder="请输入用户ID" clearable></el-input>
            </el-form-item>
            <el-form-item label="币种：" prop="coinType">
              <el-input class="tx-common-input" v-model="newTrans.coinType" placeholder="请输入币种" clearable></el-input>
            </el-form-item>
            <el-form-item label="源地址：" prop="txFromWallet">
              <el-input class="tx-common-input" v-model="newTrans.txFromWallet" placeholder="请输入源地址"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="目的地址：" prop="txToWallet">
              <el-input class="tx-common-input" v-model="newTrans.txToWallet" placeholder="请输入目的地址"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="目的memo：" prop="txToMemo">
              <el-input class="tx-common-input" v-model="newTrans.txToMemo" placeholder="请输入目的memo"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="交易数量：" prop="txAmount">
              <el-input class="tx-common-input" v-model="newTrans.txAmount" placeholder="请输入交易数量" clearable></el-input>
            </el-form-item>
            <el-form-item label="区块高度：" prop="heightInit">
              <el-input class="tx-common-input" v-model="newTrans.heightInit" placeholder="请输入区块高度"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="交易Hash：" prop="txNetworkId">
              <el-input class="tx-address-input" v-model="newTrans.txNetworkId" placeholder="请输入交易Hash"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="区块时间：">
              <el-date-picker v-model="txNetworkTime" type="datetime" placeholder="选择区块时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="交易附加信息：" prop="extraInfo">
              <el-input class="tx-common-input" v-model="newTrans.extraInfo" placeholder="请输入交易附加信息"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="remark：" prop="remark">
              <el-input class="tx-address-input" v-model="newTrans.remark"
                        placeholder="请输入[手工录入] + 录入者信息， 比如 : [手工录入]某某员工" clearable></el-input>
            </el-form-item>

            <el-button type="primary" size="medium" @click="handleSave('newTrans')">
              提交
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyForm')">保存</el-button>
      </span> -->
    </el-card>
  </div>
</template>

<script>
import "./store";
import {mapActions} from "vuex";

export default {
  name: "CreateCurrency",
  data() {
    return {
      txNetworkTime: '',
      newTrans: {
        userId: '',
        coinType: '',
        txFromWallet: '',
        txToWallet: '',
        txToMemo: '',
        txAmount: '',
        heightInit: '',
        txNetworkId: '',
        txNetworkTime: '',
        extraInfo: '',
        remark: ''
      },
      rules: {
        "userId": [{required: true, message: "请输入用户Id"}],
        "coinType": [{required: true, message: "请输入币种"}],
        "txToWallet": [{required: true, message: "请输入目的地址"}],
        "txAmount": [{required: true, message: "请输入交易数量"}],
        "heightInit": [{required: true, message: "请输入区块高度"}],
        "txNetworkId": [{required: true, message: "请输入交易Hash"}],
        "txNetworkTime": [{required: true, message: "选择区块时间"}],
        "remark": [{required: true, message: "请输入[手工录入] + 录入者信息， 比如 : [手工录入]某某员工"}]
      }
    };
  },
  methods: {
    ...mapActions("depositManual", ["create"]),
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (!this.txNetworkTime) {
          this.$message({
            showClose: true,
            message: '请选择区块时间',
            type: 'error'
          });
          return;
        }
        if (valid) {
          if (this.txNetworkTime) this.newTrans.txNetworkTime = this.txNetworkTime.getTime();
          this.$confirm('充值金额为<' + this.newTrans.txAmount + '>点击确认再入账？', '警告', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let searchValue = /^\s+|\s+$/g; //前后空格适配
            this.newTrans.userId = this.newTrans.userId.replace(searchValue, '') // 去除 userId 的前后空格
            this.newTrans.coinType = this.newTrans.coinType.replace(searchValue, '') // 去除 coinType 的前后空格
            this.newTrans.txFromWallet = this.newTrans.txFromWallet.replace(searchValue, '') // 去除 txFromWallet 的前后空格
            this.newTrans.txToWallet = this.newTrans.txToWallet.replace(searchValue, '') // 去除 txToWallet 的前后空格
            this.newTrans.txToMemo = this.newTrans.txToMemo.replace(searchValue, '') // 去除 memo 的前后空格
            this.newTrans.txAmount = this.newTrans.txAmount.replace(searchValue, '') // 去除 txAmount 的前后空格
            this.newTrans.heightInit = this.newTrans.heightInit.replace(searchValue, '') // 去除 heightInit 的前后空格
            this.newTrans.txNetworkId = this.newTrans.txNetworkId.replace(searchValue, '') // 去除 hash 的前后空格
            this.newTrans.extraInfo = this.newTrans.extraInfo.replace(searchValue, '') // 去除 extraInfo 的前后空格
            this.newTrans.remark = this.newTrans.remark.replace(searchValue, '') // 去除 remark 的前后空格
            this.create(this.newTrans).then(() => {
              this.$message.success("添加成功！");
              this.dialogVisible = false;
              this.$emit("refresh", {page: 1});
              this.$refs[formName].resetFields();
              this.txNetworkTime = '';
            });
          }).catch(() => {
          });
        }
      });
    },
    closeDialog() {
      this.currency = {
        info: {},
        erc20: false,
        erc20Config: {},
        eosSerious: false,
        eosSeriousConfig: {}
      };
      this.$refs["currencyForm"].resetFields();
    },
    handleRegexpSupportChange(isSupported, key) {
      if (!isSupported) {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            [key]: ""
          }
        };
      }
    },
    handleIsErc20Change(isErc20) {
      if (isErc20) {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            blockConfirm: 30,
            blockTime: 6,
            blockChainHashBuilder: ERC20_CONFIG.hash,
            blockChainAddrBuilder: ERC20_CONFIG.address,
            supportAddrVerify: true,
            addrRegexpExpress: ERC20_CONFIG.regexp
          }
        };
      } else {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            blockConfirm: "",
            blockTime: "",
            blockChainHashBuilder: "",
            blockChainAddrBuilder: "",
            supportAddrVerify: false,
            addrRegexpExpress: ""
          }
        };
      }
    },
    handleIsEosSeriousChange(isEosSerious) {
      if (isEosSerious) {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            memoNeeded: true,
            blockChainHashBuilder: EOS_SERIOUS_CONFIG.hash,
            blockChainAddrBuilder: EOS_SERIOUS_CONFIG.address,
            supportAddrVerify: true,
            addrRegexpExpress: EOS_SERIOUS_CONFIG.regexp,
            blockConfirm: 1,
            blockTime: 2
          }
        };
      } else {
        this.currency = {
          ...this.currency,
          info: {
            ...this.currency.info,
            memoNeeded: false,
            blockChainHashBuilder: "",
            blockChainAddrBuilder: "",
            supportAddrVerify: false,
            addrRegexpExpress: "",
            blockConfirm: "",
            blockTime: ""
          }
        };
      }
    }
  }
};
</script>

<style lang="less">
.tx-common-input {
  width: 300px;
}

.tx-address-input {
  width: 600px;
}

// .user-deposit-records-wrap {
//   .el-table {
//     .cell {
//       font-size: 12px;
//       text-align: center;
//     }
//   }
//   .user-deposit-pager-wrap {
//     text-align: right;
//     margin: 10px 0px;
//   }
// }
</style>
